import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PageState {
  title: string;
  breadcrumb: string[];
}

@Injectable({
  providedIn: 'root'
})
export class PageStateService {
  private pageState = new BehaviorSubject<PageState>({ title: '', breadcrumb: [] });

  getPageState() {
    return this.pageState.asObservable();
  }

  setPageState(newState: PageState) {
    this.pageState.next(newState);
  }

  updateBreadcrumb(newBreadcrumb: string[]) {
    const currentState = this.pageState.value;
    this.pageState.next({ ...currentState, breadcrumb: newBreadcrumb });
  }
}